import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Select } from 'components/fields'
import { Button } from 'components/misc'
import { apiOrganizations, apiCommon } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { modal } from 'redux/modules/app'
import { organizationsCodeListDropdownSelector } from 'redux/selectors/organizations'
import { Title } from 'components/layout'
import { getActiveRole, personId as getPersonId } from 'utils/token'
import { ROLES } from 'constants/enums'
import { get } from 'lodash'
import styles from './role-create.styl'
import { createValidate } from 'models/roles'

@apiCommon()
@apiOrganizations({
  organizationFilter: ''
})
@connect(
  state => ({
    dropdownAwardUnits: organizationsCodeListDropdownSelector(state),
    activeOrganization: state.auth.organization
  }),
  {
    modal
  }
)
@form({
  form: 'form-roles-create-role',
  validate: createValidate
})
class RoleCreate extends Component {
  static propTypes = {
    dropdownAwardUnits: PropTypes.array,
    modal: PropTypes.func,
    fetchCountriesWithStructure: PropTypes.func,
    getOrganizationCodeList: PropTypes.func.isRequired,
    organizations: PropTypes.object,
    common: PropTypes.object,
    activeOrganization: PropTypes.object,
    values: PropTypes.object,
    handleSubmit: PropTypes.func,
    roleTypes: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    change: PropTypes.func,
    fetchOrganizationContactAllowedRoles: PropTypes.func.isRequired,
    addPersonRole: PropTypes.func,
    data: PropTypes.object.isRequired,
    user: PropTypes.object,
    submitting: PropTypes.bool
  }

  static defaultProps = {
    values: {}
  }

  componentDidMount = () => {
    if (this.isSuperUser) {
      this.props.fetchCountriesWithStructure()
      return
    }

    this.props.getOrganizationCodeList({ filterCase: 'allOrgInStructure' })
  }

  isSuperUser = getActiveRole(this.props.activeOrganization) ===
    ROLES.IF_STAFF_SUPER.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.GBT.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.OA.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.SOA.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.IF_REGION.u

  handleFetchAwardUnits = (obj = {}) =>
    this.props.getOrganizationCodeList({
      filterById: obj.value,
      filterCase: 'allOrgInStructureByCountry'
    })

  render() {
    const {
      data,
      user,
      handleSubmit,
      values,
      dropdownAwardUnits,
      organizations,
      common,
      roleTypes,
      disabled,
      addPersonRole,
      submitting
    } = this.props

    const isOwnContact = getPersonId(user) === get(data, 'person.id')

    const ownContactNote = isOwnContact

    let countriesList = common.countries.list

    const isGopStaff = getActiveRole(this.props.activeOrganization) === ROLES.GOP_STAFF.u

    switch (getActiveRole(this.props.activeOrganization)) {
      case ROLES.GBT.u:
        countriesList = common.ics.list
        break
      default:
        break
    }

    return (
      <div>
        <form
          onSubmit={handleSubmit(fields =>
            addPersonRole(get(data, 'person.id'), fields, { isOwnContact })
          )}
        >
          <Title h2 intlKey="moduleTitle.add_role">
            Add role
          </Title>
          {ownContactNote}

          {isGopStaff &&
          <div className="row">
            <div className="col-xs-12">
                TODO show Sub-GOP list
            </div>
          </div>
          }

          {this.isSuperUser &&
          <div className="row">
            <div className="col-xs-12">
              <Select
                label="Country"
                name="countryId"
                intlKey="label.country"
                onSelectChange={this.handleFetchAwardUnits}
                options={countriesList}
                loading={common.loading}
                searchable
              />
            </div>
          </div>}

          <div className="row">
            <div className="col-xs-12">
              <Select
                label="Organizations"
                name="organizationId"
                intlKey="label.organizations"
                options={dropdownAwardUnits}
                loading={organizations.loading}
                disabled={this.isSuperUser && !values.countryId && organizations.loading}
                searchable
                onSelectChange={obj => {
                  this.props.change('organizationContactRoleType.value', null)
                  this.props.fetchOrganizationContactAllowedRoles(obj.value)
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Select
                label="Role"
                intlKey="label.role"
                name="organizationContactRoleType.value"
                options={roleTypes}
                disabled={!get(values, 'organizationId') || disabled}
              />
            </div>
          </div>
          <div className={`${styles.button_panel}`}>
            <div className="row">
              <div className="col-xs-6">
                <Button
                  secondary
                  intlKey="button.close"
                  type="button"
                  onClick={() => this.props.modal(null)}
                >
                  Close
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <Button intlKey="button.add" isLoading={submitting}>
                  Add
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default RoleCreate
